export default "__VITE_ASSET__Cre27bTv__"